import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import logo from "../../icons/photos/chillLogo.png"
import { getCountryCode } from "../../service/api/countryCode/countryCode"
import { setCountryArray } from "../../feature/countryArray/countryArray";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../components/button/primaryButton";
import FeedbackModal from "../components/feedback/feedback";
import ResponceToaster from "../components/responceToaster/responceToaster";

/// Scroll


const OuterHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [feedbackMessage, setFeedbackMessage] = useState("")
  const [feedbackModal, setFeedbackModal] = useState(false);
  const [handleToaster, setHandleToaster] = useState(false);

  useEffect(() => {

    let details = {};
    dispatch(
      getCountryCode(details, (res) => {

        dispatch(setCountryArray(res.data))
      }, (err) => { })
    )
  }, [])

  const handleLoginScreen = () => {
    navigate("/login");
  }

  function handleFeedbackModal(type, message) {

    setFeedbackMessage(message)
    setFeedbackModal(false);
    setHandleToaster(true);
    setTimeout(() => {
      setHandleToaster(false);
    }, 11000);
  }


  return (
    <div>
      <div className="" style={{ height: '60px', display: 'flex', marginLeft: '5%', marginRight: '5%', marginTop: '10px' }}>
        <div style={{ display: 'flex', justifyContent: 'flex-start', width: '50%', alignItems: 'center' }}>
          <img src={logo} onClick={handleLoginScreen} style={{ width: '100px', cursor: 'pointer' }} alt="" />
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '50%', alignItems: 'center', color: '#263238' }}>
          {/* <p><strong>Need Help?</strong> Watch tutorial video for <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>Customer</span> and <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>Pro.</span></p> */}
          {/* <PrimaryButton
            buttonName="Feedback"
            onClick={() => {
              setFeedbackModal(true);
            }}
          /> */}
          <span onClick={() => {
            setFeedbackModal(true);
          }} style={{ textDecoration: 'underline', cursor: 'pointer' }}>{"Give us feedback"}</span>
        </div>

      </div>

      {feedbackModal && (
        <FeedbackModal
          addUserTrigger={feedbackModal}
          handleCloseAddUser={handleFeedbackModal}
        />
      )}

      {handleToaster && (
        <ResponceToaster toasterType={"success"} message={feedbackMessage} />
      )}
    </div>
  );
};

export default OuterHeader;
